import {
  Box,
  Button,
  Center,
  Heading,
  Icon,
  Stack,
  Text,
} from "@chakra-ui/react";
import { MdError, MdRefresh } from "react-icons/md";

export const DefaultErrorView = ({
  message = "An error occurred. Please try again.",
}: {
  message?: string;
}) => {
  return (
    <Center minH="400px" p={8}>
      <Stack gap={6} align="center" textAlign="center">
        <Icon as={MdError} w={16} h={16} color="red.500" />
        <Box>
          <Heading size="lg" mb={2}>
            Oops!
          </Heading>
          <Text color="gray.600">{message}</Text>
        </Box>
        <Button colorScheme="blue" onClick={() => window.location.reload()}>
          <Icon as={MdRefresh} />
          Refresh Page
        </Button>
      </Stack>
    </Center>
  );
};
